import { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";

export default function Navbar({ footerRef }) {
  const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation(); // current route

  const toggleMenu = () => setIsOpen(!isOpen);

  const navItems = [
    { label: "Home", path: "/" },
    { label: "Event", path: "/event" },
    { label: "Gallery", path: "/gallery" },
    { label: "Contact", path: "#footer" }, // use lowercase id
  ];

  const handleNav = (path) => {
    if (path.startsWith("#")) {
      // Smooth scroll to footer
      if (location.pathname !== "/") {
        navigate("/"); // go to home page first
        setTimeout(() => {
          footerRef?.current?.scrollIntoView({ behavior: "smooth" });
        }, 300); // slight delay for DOM render
      } else {
        footerRef?.current?.scrollIntoView({ behavior: "smooth" });
      }
    } else {
      navigate(path);
    }
    setIsOpen(false);
  };

  return (
    <nav className="bg-white shadow-md px-6 py-4 flex flex-col md:flex-row md:justify-between md:items-center space-y-4 md:space-y-0 relative">
      {/* Logo & NGO Name */}
      <div className="flex justify-between items-center w-full md:w-auto">
        <div className="flex items-center gap-3">
          <img
            src="/assets/NANBHAT CHESS logo.jpg"
            alt="Logo"
            className="h-[60px] object-cover rounded-full"
          />
          <h1 className="text-xl sm:text-2xl md:text-3xl font-bold text-brandRed tracking-wide font-neuton">
            Nanbhat Janhith Society
          </h1>
        </div>

        {/* Hamburger Icon */}
        <div className="md:hidden">
          <button
            onClick={toggleMenu}
            className="text-gray-700 focus:outline-none"
          >
            {isOpen ? <X size={28} /> : <Menu size={28} />}
          </button>
        </div>
      </div>

      {/* Nav Links */}
      <ul
        className={`${
          isOpen ? "flex" : "hidden"
        } flex-col md:flex md:flex-row md:items-center md:space-x-6 text-gray-700 font-brand font-medium text-sm w-full md:w-auto pt-3 md:pt-0 space-y-2 md:space-y-0 border-t md:border-t-0 mt-2 md:mt-0`}
      >
        {navItems.map((item) => (
          <li key={item.label} className="w-full md:w-auto">
            <button
              onClick={() => handleNav(item.path)}
              className="w-full md:w-auto p-2 text-left transition-transform duration-200 hover:text-brandRed hover:underline hover:underline-offset-4 hover:translate-x-1"
            >
              {item.label}
            </button>
          </li>
        ))}
        <li className="w-full md:w-auto pt-1 md:pt-0">
          <a
            href="https://forms.gle/L5LzaPyM5tRgtQ1i9"
            target="_blank"
            rel="noopener noreferrer"
            className="block text-center md:inline-block bg-brandRed text-white px-5 py-2.5 rounded-full font-semibold text-xs sm:text-sm hover:bg-red-700 transition-all duration-200 shadow hover:scale-105 active:scale-95"
          >
            Register Now
          </a>
        </li>
      </ul>
    </nav>
  );
}
